import { postPurchaseFlowStepArraySchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

export const getPostPurchaseFlowSteps = {
  name: "getPostPurchaseFlowSteps" as const,
  input: z.null(),
  output: z.object({ steps: postPurchaseFlowStepArraySchema }),
};
export type GetPostPurchaseFlowStepsOutput = z.infer<
  typeof getPostPurchaseFlowSteps.output
>;
